import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pagination-main bg-white" }
const _hoisted_2 = {
  key: 0,
  class: "w-100 h-100 py-5 d-flex flex-column align-items-center justify-content-center flex-grow-1"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt fa-7x animate-flash mb-3" }, null, -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  class: "w-100 h-100 py-5 d-flex flex-column align-items-center justify-content-center flex-grow-1"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-size-3xl" }, " No Employees Found. ", -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "w-100 h-100 py-5 d-flex flex-column align-items-center justify-content-center flex-grow-1"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("There was an error while fetching the employee list."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Please try again.")
], -1 /* HOISTED */)
const _hoisted_9 = { class: "d-flex flex-wrap ms-auto align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center me-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "legend ax-calendar-event legend-success me-1" }),
  /*#__PURE__*/_createElementVNode("span", null, "Completed")
], -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center me-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "legend ax-calendar-event legend-danger me-1" }),
  /*#__PURE__*/_createElementVNode("span", null, "Missed")
], -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "legend ax-calendar-event legend-non-visit-bg me-1" }),
  /*#__PURE__*/_createElementVNode("span", null, "Non-Visit Activity")
], -1 /* HOISTED */)
const _hoisted_13 = { class: "d-flex align-items-center ms-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-home fa-md me-1 cursor pointer" }, null, -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "EVV Statuses", -1 /* HOISTED */)
const _hoisted_16 = {
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary ms-1" }, null, -1 /* HOISTED */)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "d-flex h-100"
}
const _hoisted_20 = {
  key: 2,
  class: "d-flex h-100"
}
const _hoisted_21 = {
  key: 3,
  class: "h-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarFilters = _resolveComponent("CalendarFilters")!
  const _component_EmployeeCalendarContent = _resolveComponent("EmployeeCalendarContent")!
  const _component_DailyCalendarContent = _resolveComponent("DailyCalendarContent")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_EmployeeMap = _resolveComponent("EmployeeMap")!
  const _component_SummaryView = _resolveComponent("SummaryView")!
  const _component_FindNearbyClients = _resolveComponent("FindNearbyClients")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(`calendar-layout ${_ctx.listView === _ctx.CalendarViewTypeEnum.Map || _ctx.showFindNearByClientsView || _ctx.isEmployeeLoading ? 'h-100' : ''}`)
  }, [
    (_ctx.showCalendar || _ctx.listView === _ctx.CalendarViewTypeEnum.SummaryView)
      ? (_openBlock(), _createBlock(_component_CalendarFilters, {
          key: 0,
          listView: _ctx.listView,
          isEmployeeCalendar: true,
          startDate: _ctx.startDate,
          endDate: _ctx.endDate,
          dailyDate: _ctx.dailyDate,
          updateDateRange: _ctx.updateDateRange,
          dailyDateUpdate: _ctx.dailyDateUpdate,
          employeeRefresh: _ctx.employeeRefresh,
          handleViewChange: _ctx.handleViewChange,
          showMainHeader: _ctx.showMainHeader
        }, null, 8 /* PROPS */, ["listView", "startDate", "endDate", "dailyDate", "updateDateRange", "dailyDateUpdate", "employeeRefresh", "handleViewChange", "showMainHeader"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("section", {
      class: _normalizeClass(`calendar-content  d-${_ctx.showCalendar && _ctx.listView !== _ctx.CalendarViewTypeEnum.SummaryView ? 'flex' : 'none'} flex-column mb-4`)
    }, [
      _createVNode(_component_Pagination, {
        ref: "employeeCalendarPagination",
        entity: "employees",
        classes: "pagination-footer",
        pageChanged: _ctx.pageChanged,
        isLoading: _ctx.isEmployeeLoading,
        pageSize: _ctx.pageSize,
        onUpdatePageSizeChanged: _ctx.updatePageSizeChanged,
        showPageSizeOptions: false
      }, _createSlots({
        default: _withCtx(() => [
          _createElementVNode("section", _hoisted_1, [
            (_ctx.isEmployeeLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("h4", null, "Loading " + _toDisplayString(_ctx.listView) + " Calendar...", 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            (!_ctx.hasData || _ctx.isError)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (!_ctx.hasData && !_ctx.isEmployeeLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                    : _createCommentVNode("v-if", true),
                  (_ctx.isError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("button", {
                          class: "btn btn-primary btn-sm",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pageReset()))
                        }, "Try Again")
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            (_ctx.listView === _ctx.CalendarViewTypeEnum.Weekly)
              ? (_openBlock(), _createBlock(_component_EmployeeCalendarContent, {
                  key: 2,
                  class: "employee-calendar",
                  startDate: _ctx.startDate,
                  endDate: _ctx.endDate,
                  usersList: _ctx.employees,
                  tasksList: _ctx.tasks,
                  tasksMap: _ctx.tasksMap,
                  isPremiumByAgency: _ctx.isPremiumByAgency,
                  toggleFindNearByClientsView: _ctx.toggleFindNearByClientsView,
                  onCalendarRefresh: _ctx.pageReset
                }, null, 8 /* PROPS */, ["startDate", "endDate", "usersList", "tasksList", "tasksMap", "isPremiumByAgency", "toggleFindNearByClientsView", "onCalendarRefresh"]))
              : _createCommentVNode("v-if", true),
            (_ctx.listView === _ctx.CalendarViewTypeEnum.Daily)
              ? (_openBlock(), _createBlock(_component_DailyCalendarContent, {
                  key: 3,
                  class: "employee-calendar",
                  startDate: _ctx.dailyDate,
                  endDate: _ctx.dailyDate,
                  usersList: _ctx.employees,
                  tasksList: _ctx.tasks,
                  tasksMap: _ctx.tasksMap,
                  isPremiumByAgency: _ctx.isPremiumByAgency,
                  toggleFindNearByClientsView: _ctx.toggleFindNearByClientsView,
                  onCalendarRefresh: _ctx.pageReset
                }, null, 8 /* PROPS */, ["startDate", "endDate", "usersList", "tasksList", "tasksMap", "isPremiumByAgency", "toggleFindNearByClientsView", "onCalendarRefresh"]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _: 2 /* DYNAMIC */
      }, [
        (_ctx.hasData)
          ? {
              name: "legend",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _hoisted_15,
                    _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_16, _hoisted_18)), [
                      [_directive_custom_popover, {
                                    content: _ctx.tooltip,
                                    placement: 'top',
                                    className: 'w-10 font-size-sm '
                                }]
                    ])
                  ])
                ])
              ])
            }
          : undefined
      ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["pageChanged", "isLoading", "pageSize", "onUpdatePageSizeChanged"])
    ], 2 /* CLASS */),
    (_ctx.listView === _ctx.CalendarViewTypeEnum.Map)
      ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
          _createVNode(_component_EmployeeMap, {
            listView: _ctx.listView,
            isEmployeeCalendar: true,
            handleViewChange: _ctx.handleViewChange
          }, null, 8 /* PROPS */, ["listView", "handleViewChange"])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.listView === _ctx.CalendarViewTypeEnum.SummaryView)
      ? (_openBlock(), _createElementBlock("section", _hoisted_20, [
          _createVNode(_component_SummaryView, { employeeFilterOptions: _ctx.employeeFilterOptions }, null, 8 /* PROPS */, ["employeeFilterOptions"])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.showFindNearByClientsView)
      ? (_openBlock(), _createElementBlock("section", _hoisted_21, [
          _createVNode(_component_FindNearbyClients, {
            toggleFindNearByClientsView: _ctx.toggleFindNearByClientsView,
            selectedEmployeeDetails: _ctx.selectedEmployeeForFindNearbyClient
          }, null, 8 /* PROPS */, ["toggleFindNearByClientsView", "selectedEmployeeDetails"])
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}